import { Mark, mergeAttributes } from '@tiptap/core';

export const BrandColor = Mark.create({
  name: 'brandColor',
  addAttributes() { return { token: { default: null, parseHTML: (element) => element.getAttribute('data-brand-color'), renderHTML: ({ token }) => token ? { 'data-brand-color': token, style: `color:var(--${token.replace(/[A-Z]/g, (v) => `-${v.toLowerCase()}`)})` } : {} } }; },
  parseHTML() { return [{ tag: 'span[data-brand-color]' }]; },
  renderHTML({ HTMLAttributes }) { return ['span', mergeAttributes(HTMLAttributes), 0]; },
  addCommands() { return { setBrandColor: (token) => ({ commands }) => commands.setMark(this.name, { token }), unsetBrandColor: () => ({ commands }) => commands.unsetMark(this.name) }; },
});
